module.exports = "/_next/static/images/sa1-monotone-1bbbe83a66f47eabeea7c368e48e53e4.svg";